import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class CodeEditor extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-code-editor');

    this.start();
    return super.initialize();
  }

  start() {
    this.elements.each((index, element) => {
      this.editor( $(element) );
    });
  }

  editor(container) {

    let language = container.data('language'),
        template = container.data('template') || 'tomorrow_night_eighties',
        textarea = container.next('textarea.is-hidden');

    let editor = ace.edit(container.attr('id'));
    editor.setTheme('ace/theme/'+ template);
    editor.session.setMode('ace/mode/'+ language);
    editor.setAutoScrollEditorIntoView(true);
    editor.setOption('minLines', 1);
    editor.setOption('maxLines', 40);
    editor.renderer.setScrollMargin(6, 5, 8, 5);
    editor.on('change', function(e) {
      console.log('Changed:', textarea);
      textarea.val(editor.getValue());
      console.log('New value:', textarea.val());
    });

    if (container.hasClass('is-small')) {
      editor.session.setUseWrapMode(true);
      editor.session.setTabSize(0);
      editor.setOption('wrap', true);
      editor.setOption('indentedSoftWrap', false);
      editor.setOption('highlightActiveLine', false);
      editor.setOption('showGutter', false);
      editor.setOption('highlightGutterLine', false);
      editor.setOption('showPrintMargin', false);
      editor.setOption('cursorStyle', 'slim');
    }


  }

}